// eslint-disable-next-line
declare var __webpack_public_path__: string;
// eslint-disable-next-line
__webpack_public_path__ = (window as any).__PUBLIC_PATH as string || './';

// eslint-disable-next-line
export default __webpack_public_path__;
